/// <amd-module name="TFS/TeamProfilePanel/ItemsTab" />
import * as React from "react";
import * as Resources from "TFS/TeamProfilePanel/Resources";
import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { VssComponent } from "VSS/Platform/Layout";
import { Dropdown } from "VSSUI/Dropdown";
import { Icon } from "VSSUI/Icon";
import { ScrollableList } from "VSSUI/List";
import { Observer } from "VSSUI/Observer";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { ITeamPanelItem, ITeamPanelItemView } from "./Models";
import { TeamProfilePanelFavoriteButton } from "./TeamProfilePanelFavoriteButton";
import { ITeamProfilePanelService } from "./TeamProfilePanelService";

export interface IItemsTabProps {
    teamId: string;
    teamName: string;
}

export class ItemsTab extends VssComponent<IItemsTabProps> {
    private service = this.context.pageContext.getService<ITeamProfilePanelService>("ITeamProfilePanelService");
    private hubSelection = this.service.getHubSelection();

    public render() {
        const { teamId, teamName } = this.props;
        return (
            <Observer dropdownItems={this.service.getDropdownItems()} isLoading={this.service.getIsLoadingItems()}>
                {(props: { dropdownItems: string[]; isLoading: boolean }) => {
                    return props.isLoading ? (
                        <Spinner className="flex flex-center" size={SpinnerSize.large} label={Resources.Loading} />
                    ) : (
                        <div className="flex-column margin-top-16">
                            <Dropdown
                                ariaLabel={Resources.Dropdown}
                                items={props.dropdownItems}
                                onSelect={(event) => event.preventDefault()}
                                selection={this.hubSelection}
                            />
                            <ScrollableList
                                ariaLabel={Resources.Items}
                                className="content-row"
                                itemProvider={this.service.getItemProvider(teamId, teamName)}
                                renderRow={this.renderListRow}
                            />
                        </div>
                    );
                }}
            </Observer>
        );
    }

    private renderListRow = (rowIndex: number, panelItem: ITeamPanelItemView) => {
        const item: ITeamPanelItem = panelItem.item;
        return (
            <div
                className="item-panel-row flex-center flex-row margin-top-8 padding-left-8 subtle-border"
                data-is-focusable={true}
                aria-label={Resources.Items}
                key={panelItem.hub + panelItem.item.artifactId}
            >
                <Icon className="font-size-l padding-top-4" iconName={item?.iconClassName} />
                <div className="flex-column margin-left-16">
                    <FPSLink ariaLabel={item?.name} className="item-title" href={item?.href}>
                        {item?.name}
                    </FPSLink>
                    {panelItem.hub}
                </div>
                <div className="favorite icon-margin">
                    <TeamProfilePanelFavoriteButton itemView={panelItem} />
                </div>
            </div>
        );
    };
}
